// Simple fuzzy search utility
export const fuzzySearch = (items: any[], searchTerm: string, searchFields: string[]) => {
  if (!searchTerm.trim()) return items;

  const searchLower = searchTerm.toLowerCase();

  return items.filter((item) => {
    return searchFields.some((field) => {
      const value = getNestedValue(item, field);
      return value?.toString().toLowerCase().includes(searchLower);
    });
  });
};

// Helper to get nested object values (e.g., "metadata.brandCode")
const getNestedValue = (obj: any, path: string) => {
  return path.split('.').reduce((current, key) => current?.[key], obj);
};

// Pagination utility
export const paginateData = (data: any[], currentPage: number, pageSize: number) => {
  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = startIndex + pageSize;
  return data.slice(startIndex, endIndex);
};
